window.variantImages = function variantImages() {
  document.querySelectorAll(".wdgt").forEach((cardWrapper) => {
    const imageAnchor = cardWrapper.querySelector(".wdgt-image-container a");
    const secondaryHoverWrapper = cardWrapper.querySelector(
      ".wdgt-secondary-hvr"
    );

    // Salva o HTML original
    const originalImageHTML = imageAnchor ? imageAnchor.innerHTML : null;
    let isImageChanged = false;

    // B2B-only SKU line (.wdgt-sku): keep it in sync when the metal/color
    // swatch swaps the card to a sibling product. The sku is read from the
    // swatch's product-list-json payload; the original is restored on reset.
    const skuEl = cardWrapper.querySelector(".wdgt-sku");
    const originalSkuText = skuEl ? skuEl.textContent : null;

    function skuFromSwatch(swatch) {
      const jsonEl = swatch.querySelector(".product-list-json");
      if (!jsonEl) return null;
      try {
        const variants = JSON.parse(jsonEl.textContent);
        if (!Array.isArray(variants) || !variants.length) return null;
        const chosen = variants.find((v) => v && v.available) || variants[0];
        return chosen && chosen.sku ? chosen.sku : null;
      } catch (e) {
        return null;
      }
    }

    function resetImages() {
      if (isImageChanged && originalImageHTML && imageAnchor) {
        imageAnchor.innerHTML = originalImageHTML;
        isImageChanged = false;
      }
    }

    const variationSwatches = cardWrapper.querySelectorAll(
      ".product_variant__swatch"
    );

    variationSwatches.forEach((swatch) => {
      swatch.addEventListener("click", function (event) {
        variationSwatches.forEach((s) => s.classList.remove("active_swatch"));
        swatch.classList.add("active_swatch");
        // Não bloquear cliques em botões
        if (!event.target.closest('button')) {
          event.stopPropagation();
        }

        const newImages = swatch.querySelectorAll(".image-cards img");

        if (!newImages.length || !imageAnchor) return;

        imageAnchor.innerHTML = "";

        if (newImages.length >= 2) {
          const hoverWrapper = document.createElement("div");
          hoverWrapper.className = "wdgt-secondary-hvr";

          const originalDiv = document.createElement("div");
          originalDiv.className = "wdgt-secondary-hvr--original";
          originalDiv.appendChild(newImages[0].cloneNode(true));

          const secondaryDiv = document.createElement("div");
          secondaryDiv.className = "wdgt-secondary-hvr--secondary";
          secondaryDiv.appendChild(newImages[1].cloneNode(true));

          hoverWrapper.appendChild(originalDiv);
          hoverWrapper.appendChild(secondaryDiv);
          imageAnchor.appendChild(hoverWrapper);
        } else if (newImages.length === 1) {
          imageAnchor.appendChild(newImages[0].cloneNode(true));
        }

        const productUrl = swatch.querySelector('.image-cards.hidden')?.getAttribute('data-product-url');
        if (productUrl) {
          cardWrapper.querySelectorAll('.wdgt-image-link').forEach(link => {
            link.setAttribute('href', productUrl);
          })
        }

        if (skuEl) {
          const newSku = skuFromSwatch(swatch);
          if (newSku) skuEl.textContent = newSku;
        }

        isImageChanged = true;

        document.addEventListener("click", function (e) {

          if (!cardWrapper.contains(e.target)) {
            resetImages();
            variationSwatches.forEach((s) => s.classList.remove("active_swatch"));

            if (skuEl && originalSkuText !== null) {
              skuEl.textContent = originalSkuText;
            }

            const defaultUrl = cardWrapper.getAttribute('data-default-url');
            if (defaultUrl) {
              cardWrapper.querySelectorAll('.wdgt-image-link').forEach(link => {
                link.setAttribute('href', defaultUrl);
              })
            }
          }
          /* if (!e.target.closest(".product_variant__swatch") && !e.target.closest('button')) {
            resetImages();
          } */
        });
      });
    });
  });
};

document.addEventListener("DOMContentLoaded", () => {
  variantImages();
});

document.addEventListener("facetsUpdated", function () {
  variantImages();
});
